import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  TextField,
} from '@mui/material';
// components
import Label from '../components/label';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';
import { BACK } from '../config';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'name', label: 'Name', alignRight: false },
  { id: 'company', label: 'Company', alignRight: false },
  { id: 'role', label: 'Role', alignRight: false },
  { id: 'isVerified', label: 'Verified', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  { id: '' },
];

const TALBE_HEAD1 = [
  { id: 'id', label: 'ID', alignRight: false },
  { id: 'password', label: 'PASSWORD', alignRight: false },
  { id: 'name', label: 'NAME', alignRight: false },
  { id: 'phoneNum', label: 'PHONE_NUM', alignRight: false },
  { id: 'investCnt', label: 'INVEST_CNT', alignRight: false },
  { id: '' },
];

const TALBE_HEAD2 = [
  { id: 'idx', label: 'IDX', alignRight: false },
  { id: 'carNum', label: 'CAR_NUM', alignRight: false },
  { id: 'illegal', label: 'ILLEGAL', alignRight: false },
  { id: 'longitude', label: 'LONGITUDE', alignRight: false },
  { id: 'latitude', label: 'LATITUDE', alignRight: false },
  { id: 'date', label: 'DATE', alignRight: false },
  { id: 'dayNight', label: 'DAY_NIGHT', alignRight: false },
];

const TALBE_HEAD3 = [
  { id: 'idx', label: 'IDX', alignRight: false },
  { id: 'carNum', label: 'CAR_NUM', alignRight: false },
  { id: 'illegal', label: 'ILLEGAL', alignRight: false },
  { id: 'longitude', label: 'LONGITUDE', alignRight: false },
  { id: 'latitude', label: 'LATITUDE', alignRight: false },
  { id: 'date', label: 'DATE', alignRight: false },
  { id: 'dayNight', label: 'DAY_NIGHT', alignRight: false },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query, orderBy) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user[orderBy].toString().toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

function Menu2() {
  if (localStorage.getItem('id') === 'woosung') {
    return <></>;
  }
  return (
    <TableCell
      style={{ background: 'darkviolet', color: 'lightgray' }}
      onClick={() => {
        window.location.href = '/investigation';
      }}
    >
      <Typography variant="h4" gutterBottom>
        조사결과 조회
      </Typography>
    </TableCell>
  );
}
export default function InvestorPage() {
  const [USERLIST, setUSERLIST] = useState([]);
  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('name');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [inputName, setInputName] = useState('');

  const [inputPhoneNum, setInputPhoneNum] = useState('');

  useEffect(() => {
    fetch(`${BACK}/readInvestor`, {
      method: 'GET',
    })
      .then((res) => {
        console.log(res.status);
        return res.json();
      })
      .then((data) => {
        console.log(data);
        setUSERLIST(data.rows);
      })
      .catch((err) => console.log(err));
  }, []);

  const addInvestor = () => {
    if (inputPhoneNum.length !== 11) {
      alert('전화번호 11자리를 다시 입력해주세요.');
      return;
    }
    fetch(`${BACK}/createInvestor`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name: inputName,
        phoneNum: inputPhoneNum,
      }),
    })
      .then((res) => {
        console.log(res.status);
        return res.json();
      })
      .then((data) => {
        console.log(data);
        window.location.reload();
      });
  };

  const deleteInvestor = (id) => {
    if (window.confirm('정말로 삭제하실건가요?')) {
      fetch(`${BACK}/deleteInvestor`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id,
        }),
      })
        .then((res) => {
          console.log(res.status);
          return res.json();
        })
        .then((data) => {
          console.log(data);
          window.location.reload();
        });
    }
  };

  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = USERLIST.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - USERLIST.length) : 0;

  const filteredUsers = applySortFilter(USERLIST, getComparator(order, orderBy), filterName, orderBy);

  const isNotFound = !filteredUsers.length && !!filterName;

  return (
    <>
      <Helmet>
        <title> 창일 </title>
      </Helmet>

      <Container>
        <Stack direction="col" alignItems="center" justifyContent="space-between" mb={5}>
          <Table>
            <TableRow>
              <TableCell
                style={{ background: 'blueviolet', color: 'white' }}
                onClick={() => {
                  window.location.href = '/';
                }}
              >
                <Typography variant="h4" gutterBottom>
                  조사자 관리
                </Typography>
              </TableCell>
              <Menu2 />
              <TableCell
                style={{ background: 'darkviolet', color: 'lightgray' }}
                onClick={() => {
                  window.location.href = '/personalInvestigation';
                }}
              >
                <Stack direction="col" justifyContent="space-between">
                  <Typography variant="h4" gutterBottom>
                    조사자별 조회
                  </Typography>
                  <Button
                    style={{ backgroundColor: 'white' }}
                    variant="outlined"
                    onClick={() => {
                      localStorage.removeItem('token');
                      localStorage.removeItem('id');
                      localStorage.removeItem('name');
                      localStorage.removeItem('type');
                      window.location.href = '/';
                    }}
                  >
                    로그아웃
                  </Button>
                </Stack>
              </TableCell>
            </TableRow>
          </Table>
        </Stack>

        <Card>
          <UserListToolbar
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
            orderBy={orderBy}
          />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TALBE_HEAD1}
                  rowCount={USERLIST.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                    const { _id, id, password, name, phoneNum, investCnt } = row;
                    const selectedUser = selected.indexOf(name) !== -1;

                    return (
                      <TableRow hover key={id} tabIndex={-1} role="checkbox" selected={selectedUser}>
                        <TableCell component="th" scope="row" padding="none" width={'100px'}>
                          <Typography variant="subtitle2" noWrap textAlign={'center'}>
                            {id}
                          </Typography>
                        </TableCell>

                        <TableCell align="left">{password}</TableCell>

                        <TableCell align="left">{name}</TableCell>

                        <TableCell align="left">{phoneNum}</TableCell>

                        <TableCell align="left">{investCnt}</TableCell>

                        <TableCell align="right">
                          <IconButton size="large" color="inherit" onClick={() => deleteInvestor(id)}>
                            <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 76.59 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                  <TableRow hover tabIndex={-1}>
                    <TableCell component="th" scope="row" padding="none">
                      <TextField
                        key={inputPhoneNum}
                        disabled
                        variant="standard"
                        defaultValue={inputPhoneNum.slice(3)}
                      />
                    </TableCell>

                    <TableCell align="left">
                      <TextField
                        key={inputPhoneNum}
                        disabled
                        variant="standard"
                        defaultValue={inputPhoneNum.slice(7)}
                      />
                    </TableCell>

                    <TableCell align="left">
                      <TextField
                        variant="standard"
                        defaultValue={inputName}
                        onChange={(e) => setInputName(e.target.value)}
                      />
                    </TableCell>

                    <TableCell align="left">
                      <TextField
                        variant="standard"
                        defaultValue={inputPhoneNum}
                        onChange={(e) => setInputPhoneNum(e.target.value)}
                      />
                    </TableCell>

                    <TableCell align="left">
                      <TextField disabled variant="standard" defaultValue={0} />
                    </TableCell>

                    <TableCell align="right">
                      <IconButton size="large" color="inherit" onClick={addInvestor}>
                        <Iconify icon={'eva:plus-outline'} sx={{ mr: 2 }} />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                </TableBody>

                {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="h6" paragraph>
                            찾을 수 없습니다.
                          </Typography>

                          <Typography variant="body2">
                            <strong>&quot;{filterName}&quot;</strong>에 대한 결과가 없습니다.
                            <br /> 오타가 있는지 확인하거나 단어를 끝까지 입력해주세요.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredUsers.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage="페이지 당 개수"
          />
        </Card>
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem>
          <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
          수정
        </MenuItem>

        <MenuItem sx={{ color: 'error.main' }}>
          <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
          삭제
        </MenuItem>
      </Popover>
    </>
  );
}
